module.exports = __webpack_public_path__ + "img/cartes-bancaires.f32b8345.svg";